<template>
    <div>
        <a-card :title="$t('edit.editActionTitles.senceMaskSets')" :bordered="false">
            <div class="mask-global-box">
                <MaskItem :url="form.fix_logo.land" requireSize="500 x 500" :title="$t('edit.settings.fixMap')"
                    :is-edit="userInfo.level > 0 || userInfo.team_id > 0" :scale="form.fix_logo.land_scale"
                    :angle="form.fix_logo.land_angle" @updateData="updateGlobalLand" @deleteData="deleteGlobalLand"
                    @changeScale="handleGooblaLandScaleChange" @changeRotate="handleGooblaLandRotateChange"
                    @shadeSave="updateStore"></MaskItem>
            </div>
            <div class="mask-global-box">
                <MaskItem :url="form.fix_logo.sky" requireSize="500 x 500" :title="$t('edit.settings.fixSky')"
                    :is-edit="userInfo.level > 0 || userInfo.team_id > 0" :scale="form.fix_logo.sky_scale"
                    :angle="form.fix_logo.sky_angle" @updateData="updateGlobalSky" @deleteData="deleteGlobalSky"
                    @changeScale="handleGooblaSkyScaleChange" @changeRotate="handleGooblaSkyRotateChange"
                    @shadeSave="updateStore"></MaskItem>
            </div>
            <!-- <div class="sence-list">
                        <div class="list-item" v-for="(item,index) in senceList" :key="index">
                            <div class="sence-img">
                                <img :src="item.thumb_path"/>
                            </div>
                            <div class="sence-title">{{item.scene_title}}</div>
                            <div class="mask-single-box left">
                                <div class="img-con">
                                    <img
                                            v-if="item.sky_land_shade.land && item.sky_land_shade.land != ''"
                                            :src="item.sky_land_shade.land?item.sky_land_shade.land:''"
                                    />
                                    <a-icon type="file-image" class="default-icon" v-else/>
                                </div>
                                <div class="right">
                                    <div class="titles">
                                        {{$t('edit.settings.fixMap')}}
                                        <p>
                                          <span>({{$t("descriptions.recommendSize")}}：500x500)</span>
                                        </p>
                                    </div>
                                    <div class="btns" v-if="userInfo.level > 0 || userInfo.team_id > 0">
                                        <material-select :type="1" @selected="updateSingleLand">
                                            <template slot="body">
                                                <a-button type="primary" @click="clickSingleLand(index)">
                                                    {{$t('actionTitles.changeCover')}}
                                                </a-button>
                                            </template>
                                        </material-select>
                                        <a-button type="danger" style="margin-left: 10px" @click="deleteSingleLand(index)" v-if="item.sky_land_shade.land && item.sky_land_shade.land != ''">
                                            {{$t('actionTitles.delete')}}
                                        </a-button>
                                    </div>
                                </div>

                            </div>
                            <div class="mask-single-box">
                                <div class="img-con">
                                    <img
                                            v-if="item.sky_land_shade.sky && item.sky_land_shade.sky != ''"
                                            :src="item.sky_land_shade.sky?item.sky_land_shade.sky:''"
                                    />
                                    <a-icon type="file-image" class="default-icon" v-else/>
                                </div>
                                <div class="right">
                                    <div class="titles">
                                        {{$t('edit.settings.fixSky')}}
                                        <p>
                                          <span>({{$t("descriptions.recommendSize")}}：500x500)</span>
                                        </p>
                                    </div>
                                    <div class="btns" v-if="userInfo.level > 0 || userInfo.team_id > 0">
                                        <material-select :type="1" @selected="updateSingleSky">
                                            <template slot="body">
                                                <a-button type="primary" @click="clickSingleSky(index)">
                                                    {{$t('actionTitles.changeCover')}}
                                                </a-button>
                                            </template>
                                        </material-select>
                                        <a-button type="danger" style="margin-left: 10px" @click="deleteSingleSky(index)" v-if="item.sky_land_shade.sky && item.sky_land_shade.sky != ''">
                                            {{$t('actionTitles.delete')}}
                                        </a-button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div> -->
            <!-- <global-single @handleSubmit="saveMask" @handleCancel="cancelMask" :footer="false">
                <template v-slot:global>
                    <div class="mask-global-box">
                            <MaskItem
                                    :url="form.fix_logo.land"
                                    requireSize="500 x 500"
                                    :title="$t('edit.settings.fixMap')"
                                    :is-edit="userInfo.level > 0 || userInfo.team_id > 0"
                                    :scale="form.fix_logo.land_scale"
                                    :angle="form.fix_logo.land_angle"
                                    @updateData="updateGlobalLand"
                                    @deleteData="deleteGlobalLand"
                                    @changeScale="handleGooblaLandScaleChange"
                                    @changeRotate="handleGooblaLandRotateChange"
                                    @shadeSave="updateStore"
                            ></MaskItem>
                    </div>
                    <div class="mask-global-box">
                            <MaskItem
                                    :url="form.fix_logo.sky"
                                    requireSize="500 x 500"
                                    :title="$t('edit.settings.fixSky')"
                                    :is-edit="userInfo.level > 0 || userInfo.team_id > 0"
                                    :scale="form.fix_logo.sky_scale"
                                    :angle="form.fix_logo.sky_angle"
                                    @updateData ="updateGlobalSky"
                                    @deleteData ="deleteGlobalSky"
                                    @changeScale="handleGooblaSkyScaleChange"
                                    @changeRotate="handleGooblaSkyRotateChange"
                                    @shadeSave  ="updateStore"
                            ></MaskItem>
                    </div>
                </template>
                <template v-slot:single>
                    <div class="sence-list">
                        <div class="list-item" v-for="(item,index) in senceList" :key="index">
                            <div class="sence-img">
                                <img :src="item.thumb_path"/>
                            </div>
                            <div class="sence-title">{{item.scene_title}}</div>
                            <div class="mask-single-box left">
                                <div class="img-con">
                                    <img
                                            v-if="item.sky_land_shade.land && item.sky_land_shade.land != ''"
                                            :src="item.sky_land_shade.land?item.sky_land_shade.land:''"
                                    />
                                    <a-icon type="file-image" class="default-icon" v-else/>
                                </div>
                                <div class="right">
                                    <div class="titles">
                                        {{$t('edit.settings.fixMap')}}
                                        <p>
                                          <span>({{$t("descriptions.recommendSize")}}：500x500)</span>
                                        </p>
                                    </div>
                                    <div class="btns" v-if="userInfo.level > 0 || userInfo.team_id > 0">
                                        <material-select :type="1" @selected="updateSingleLand">
                                            <template slot="body">
                                                <a-button type="primary" @click="clickSingleLand(index)">
                                                    {{$t('actionTitles.changeCover')}}
                                                </a-button>
                                            </template>
                                        </material-select>
                                        <a-button type="danger" style="margin-left: 10px" @click="deleteSingleLand(index)" v-if="item.sky_land_shade.land && item.sky_land_shade.land != ''">
                                            {{$t('actionTitles.delete')}}
                                        </a-button>
                                    </div>
                                </div>

                            </div>
                            <div class="mask-single-box">
                                <div class="img-con">
                                    <img
                                            v-if="item.sky_land_shade.sky && item.sky_land_shade.sky != ''"
                                            :src="item.sky_land_shade.sky?item.sky_land_shade.sky:''"
                                    />
                                    <a-icon type="file-image" class="default-icon" v-else/>
                                </div>
                                <div class="right">
                                    <div class="titles">
                                        {{$t('edit.settings.fixSky')}}
                                        <p>
                                          <span>({{$t("descriptions.recommendSize")}}：500x500)</span>
                                        </p>
                                    </div>
                                    <div class="btns" v-if="userInfo.level > 0 || userInfo.team_id > 0">
                                        <material-select :type="1" @selected="updateSingleSky">
                                            <template slot="body">
                                                <a-button type="primary" @click="clickSingleSky(index)">
                                                    {{$t('actionTitles.changeCover')}}
                                                </a-button>
                                            </template>
                                        </material-select>
                                        <a-button type="danger" style="margin-left: 10px" @click="deleteSingleSky(index)" v-if="item.sky_land_shade.sky && item.sky_land_shade.sky != ''">
                                            {{$t('actionTitles.delete')}}
                                        </a-button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </template>
            </global-single> -->

        </a-card>
        <!-- <div class="mask-btns">
            <a-button type="primary" @click="toggleKeepShade(keepSceneValue)">{{ keepSceneValue ? '停止跟隨場景' : '開始跟隨場景' }}</a-button>
        </div> -->
        <div class="mask-btns">
            <a-button type="primary" @click="updateStore">保存</a-button>
        </div>
    </div>
</template>

<script>
import MaskItem from "./MaskItem";
import { mapGetters, mapState } from "vuex";
export default {
    name: "MaskView",
    components: {
        MaskItem,
    },
    data() {
        return {
            form: {
                fix_logo: {
                    land: '',
                    sky: '',
                    land_angle: 0,
                    land_scale: 1,
                    sky_angle: 0,
                    sky_scale: 1,
                }
            },
            senceList: [],
            curMaskSenceId: '',
            sky_land_shade: '',
            saveTime: new Date().getTime(),
            editTarget: null,
            keepSceneValue: false,
        }
    },
    computed: {
        ...mapGetters(["vrbase", "userConfig", "userInfo"]),
    },
    created() {
        // 將vrbase的資料帶入
        this.senceList = this.$deepClone(this.vrbase.scenes)
        this.form = this.$deepClone(this.vrbase.ads)
    },
    methods: {
        // toggleKeepShade(keepShade){
        //     const groundMaskId = "shade_ground_mask_id";
        //     const skyMaskId = "shade_sky_mask_id";
        //     toggleFollowScene(groundMaskId, skyMaskId, keepShade)
        //     this.keepSceneValue = !this.keepSceneValue
        //     console.log(keepShade)
        // },
        handleGooblaLandRotateChange(rotate) {       // 控制全景地板遮罩角度
            const groundMaskId = "shade_ground_mask_id";
            const key = 'rz';
            this.form.fix_logo.land_angle = rotate;
            setShadeRotate(groundMaskId, key, rotate);
        },
        handleGooblaSkyRotateChange(rotate) {       // 控制全景天空遮罩角度
            const skyMaskId = "shade_sky_mask_id";
            const key = 'rz';
            this.form.fix_logo.sky_angle = rotate;
            setShadeRotate(skyMaskId, key, rotate);
        },
        handleGooblaLandScaleChange(scale) {       // 控制全景地板遮罩大小
            const groundMaskId = "shade_ground_mask_id";
            const key = 'scale';
            this.form.fix_logo.land_scale = parseFloat(scale);
            setShadeScale(groundMaskId, key, scale);
        },
        handleGooblaSkyScaleChange(scale) {        // 控制全景天空遮罩大小
            const skyMaskId = "shade_sky_mask_id";
            const key = 'scale';
            this.form.fix_logo.sky_scale = parseFloat(scale);
            setShadeScale(skyMaskId, key, scale);
        },
        updateStore() {     // 保存按鈕
            const vrbase = { ...this.vrbase, ads: this.form, scenes: this.senceList }
            this.$store.dispatch("saveVRBase", {
                vrbase,
                showLoading: true,
            }, true);
        },
        updateGlobalLand(data) {     //更新地板遮罩圖層
            this.form.fix_logo.land = data.url;
            const groundMaskId = "shade_ground_mask_id";
            let date = new Date();
            let currentDateParam = "?v=" + date.getFullYear() + "" + (date.getMonth() + 1) + "" + date.getDate();
            addSceneShade(groundMaskId, data.url + currentDateParam, 90, this.form.fix_logo.land_scale, this.form.fix_logo.land_angle);
        },
        deleteGlobalLand() {         //刪除地板遮罩圖層
            this.form.fix_logo.land = ''
            const groundMaskId = "shade_ground_mask_id";
            addSceneShade(groundMaskId, this.form.fix_logo.land, 90);
        },
        updateGlobalSky(data) {      //更新天空遮罩圖層
            this.form.fix_logo.sky = data.url
            const skyMaskId = "shade_sky_mask_id";
            let date = new Date();
            let currentDateParam = "?v=" + date.getFullYear() + "" + (date.getMonth() + 1) + "" + date.getDate();
            addSceneShade(skyMaskId, data.url + currentDateParam, -90, this.form.fix_logo.sky_scale, this.form.fix_logo.sky_angle);
        },
        deleteGlobalSky() {          //刪除天空遮罩圖層
            this.form.fix_logo.sky = '';
            const skyMaskId = "shade_sky_mask_id";
            addSceneShade(skyMaskId, this.form.fix_logo.sky, -90);
        },
        // updateSingleLand(data){
        //     this.$set(this.senceList[this.curMaskSenceId].sky_land_shade, "land", data.url)
        //     console.log(this.senceList)
        // },
        // clickSingleLand(index){
        //     this.curMaskSenceId = index;
        //     console.log('curMaskSenceId', this.curMaskSenceId);
        // },
        // deleteSingleLand(index){
        //     console.log(index)
        //     this.curMaskSenceId = index
        //     this.senceList[index].sky_land_shade.land = ''
        // },
        // updateSingleSky(data){
        //     this.$set(this.senceList[this.curMaskSenceId].sky_land_shade, "sky", data.url)
        //     console.log(this.senceList)
        // },
        // clickSingleSky(index){
        //     this.curMaskSenceId = index
        // },
        // deleteSingleSky(index){
        //     this.curMaskSenceId = index
        //     this.senceList[index].sky_land_shade.sky = ''
        // },
        // saveMask(){
        //     const vrbase = {...this.vrbase, ads: this.form,scenes: this.senceList}
        //     this.$store.dispatch("saveVRBase", {
        //         vrbase,
        //         showLoading: true,
        //     }, true);
        // },
        // cancelMask(){
        //     this.senceList = this.$deepClone(this.vrbase.scenes)
        //     this.form = this.$deepClone(this.vrbase.ads)
        // }
    }
}
</script>

<style lang="less" scoped>
.mask-global-box {
    display: flex;
}

.list-item {
    background-color: #2f2f2f;
    border: 1px solid #555;
    padding: 20px;
    align-items: center;
    margin-bottom: 10px;

    .sence-img {
        width: 100%;
        height: 70px;
        flex-shrink: 0;
        display: flex;
        justify-content: center;

        img {
            width: 70px;
            height: 70px;
            object-fit: contain;
        }
    }

    .sence-title {
        margin: 10px 0;
        overflow: hidden;
        word-wrap: break-word;
        display: flex;
        justify-content: center;
    }

    .mask-single-box {
        height: 100%;
        display: block;
        flex-shrink: 0;

        .img-con {
            width: 100%;
            height: 100px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #252525;
            margin-right: 10px;

            .default-icon {
                font-size: 24px;
            }

            img {
                max-width: 100px;
                max-height: 100px;
            }
        }

        .right {
            .titles {
                margin-top: 10px;

                span {
                    font-size: 12px;
                    color: rgba(255, 255, 255, .6);
                }
            }

            .btns {
                display: flex;
                margin-top: 20px;
                margin-bottom: 10px;
                justify-content: center;
            }
        }
    }
}

.mask-btns {
    display: flex;
    justify-content: space-between;
    padding: 20px;
    position: absolute;
    left: 0;
    bottom: 0;

    .saveBtn {
        background-color: #7101ad;
        border-color: #7101ad;
    }
}
</style>
